import { render } from "./AddWebsiteView.vue?vue&type=template&id=f7bd00fe"
import script from "./AddWebsiteView.vue?vue&type=script&lang=js"
export * from "./AddWebsiteView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__